import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              <i className="ri-star-line"></i>
              为什么选择我们
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              平台优势
            </h2>
            <p className="text-sm text-foreground-500 mt-2">千万吃瓜群众信赖的娱乐八卦资讯平台</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {featureItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 border border-background-200 rounded-xl p-6 text-center hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-2xl text-primary-600`}></i>
                </div>
                <h3 className="font-sans font-bold text-base text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}